// Freemium limits configuration
// Centralized constants for all free tier limitations

export const FREEMIUM_LIMITS = {
  // Chart limits
  FREE_MAX_CHARTS: 15,
  
  // Setlist limits
  FREE_MAX_SETLISTS: 1,
  FREE_MAX_SONGS_PER_SETLIST: 5,
  
  // Jam Session limits
  FREE_MAX_JAM_PARTICIPANTS: 2, // host + 1 guest
  
  // Export limits (for future use)
  FREE_MAX_PDF_EXPORTS_PER_MONTH: 0, // Premium only
} as const;

// Helper messages for upgrade prompts
export const FREEMIUM_MESSAGES = {
  CHARTS_LIMIT_REACHED: {
    title: 'Chart Limit Reached',
    message: `You've reached the free limit of ${FREEMIUM_LIMITS.FREE_MAX_CHARTS} charts. Upgrade to Premium to create unlimited charts!`,
    feature: 'basicChartEditor' as const,
  },
  
  SETLISTS_LIMIT_REACHED: {
    title: 'Setlist Limit Reached',
    message: `You've reached the free limit of ${FREEMIUM_LIMITS.FREE_MAX_SETLISTS} setlist. Upgrade to Premium to create unlimited setlists!`,
    feature: 'unlimitedSetlists' as const,
  },
  
  SONGS_LIMIT_REACHED: {
    title: 'Songs Limit Reached',
    message: `Free setlists can have a maximum of ${FREEMIUM_LIMITS.FREE_MAX_SONGS_PER_SETLIST} songs. Upgrade to Premium for unlimited songs per setlist!`,
    feature: 'unlimitedSetlists' as const,
  },
  
  JAM_PARTICIPANTS_LIMIT: {
    title: 'Jam Session Limit',
    message: `Free Jam Sessions are limited to ${FREEMIUM_LIMITS.FREE_MAX_JAM_PARTICIPANTS} participants. Upgrade to Premium for unlimited collaborators!`,
    feature: 'jamSession' as const,
  },
  
  ANNOTATIONS_EDITING_BLOCKED: {
    title: 'Premium Feature',
    message: 'Editing annotations is a Premium feature. Upgrade to add and modify annotations on your charts!',
    feature: 'annotationsEditing' as const,
  },
  
  PDF_EXPORT_BLOCKED: {
    title: 'Premium Feature',
    message: 'PDF Export is a Premium feature. Upgrade to create print-ready PDFs of your charts!',
    feature: 'pdfExport' as const,
  },
  
  CLOUD_SYNC_BLOCKED: {
    title: 'Premium Feature', 
    message: 'Cloud Sync is a Premium feature. Upgrade to access your charts from any device!',
    feature: 'cloudSync' as const,
  },
  
  GIG_MODE_SETLISTS_BLOCKED: {
    title: 'Premium Feature',
    message: 'Accessing setlists in Gig Mode is a Premium feature. Upgrade for seamless performance navigation!',
    feature: 'unlimitedSetlists' as const,
  },
} as const;

// Type for the limit message keys
export type FreemiumMessageKey = keyof typeof FREEMIUM_MESSAGES;
